import React from 'react';
import Modal from 'react-modal';
import { MdClose } from "@react-icons/all-files/md/MdClose";
import { Gallery } from "react-grid-gallery";
import "./modal.scss";

const modalStyles = {
    content: {
        width: '100%',
        maxWidth: '1000px',
        padding: 0,
        margin: 0,

    },
};



const transformImages = (images = []) => images
    ?.map(img => ({
        src: img?.original,
        height: 200,
        width: 320,
        caption: img?.caption || img?.title
    }));

const GalleryModal = ({ isOpen, onClose, imageGallery }) => {

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={modalStyles}
        >
            <div className='gallery__content__wrapper'
                style={{
                    position: "relative",
                    maxHeight: '500px',
                }}
            >
                <div className='close__modal'>
                    <MdClose onClick={onClose} cursor="pointer" />
                </div>

                <Gallery
                    enableImageSelection={false}
                    images={transformImages(imageGallery)}
                    thumbnailStyle={{ objectFit: 'cover' }}
                />

            </div>
        </Modal>
    );
};

export default GalleryModal;